import { CertificateConfigType } from '../types/Certificate';

export const defaultCertificate: Omit<CertificateConfigType, 'icon' | 'logo'> =
  {
    background: '#E7E7E7',
    color: '#E7E7E7',
    name: 'Unknown',
  };

export type CertificateImageConfig = {
  iconUrl: string;
  logoUrl: string;
  color?: string;
  name: string;
};

export const CERTIFICATES_CONFIG: Record<string, CertificateImageConfig> = {
  steam: {
    iconUrl: '/images/large/steam.png',
    logoUrl: '/images/small/steam-s.svg',
    name: 'Пополнить Steam аккаунт',
  },
  'xbox-the-crew-motorfest': {
    iconUrl: '/images/large/xbox-the-crew-motorfest.svg',
    logoUrl: '/images/small/the-crew-motorfest-s.svg',
    color: '#186F11',
    name: 'Xbox The Crew™ Motorfest',
  },
  'xbox-pubg': {
    iconUrl: '/images/large/xbox-PUBG.svg',
    logoUrl: '/images/small/PUBG-s.svg',
    color: '#186F11',
    name: 'Xbox PUBG',
  },
  'xbox-gift-card': {
    iconUrl: '/images/large/xbox-gift-card.svg',
    logoUrl: '/images/small/xbox-s.svg',
    color: '#28A715',
    name: 'Xbox gift card',
  },
  'xbox-game-pass-ultimate': {
    iconUrl: '/images/large/xbox-game-pass-ultimate.svg',
    logoUrl: '/images/small/xbox-s.svg',
    color: '#28A715',
    name: 'Xbox Game Pass Ultimate',
  },
  'xbox-game-pass-core-us': {
    iconUrl: '/images/large/xbox-game-pass-core-us.png',
    logoUrl: '/images/small/xbox-s.svg',
    color: '#28A715',
    name: 'Xbox Game Pass Core (US)',
  },
  'xbox-game-pass-core': {
    iconUrl: '/images/large/xbox-game-pass-core.svg',
    logoUrl: '/images/small/xbox-s.svg',
    color: '#28A715',
    name: 'Xbox Game Pass Core',
  },
  'xbox-ea-sports-fc-24': {
    iconUrl: '/images/large/xbox-fc-24.png',
    logoUrl: '/images/small/fc-24-s.svg',
    color: '#166B10',
    name: 'Xbox EA SPORTS™ FC 24',
  },
  'xbox-apex-legends': {
    iconUrl: '/images/large/xbox-apex-legends.svg',
    logoUrl: '/images/small/xbox-apex-legends-s.svg',
    color: '#166B10',
    name: 'Xbox Apex Legends',
  },
  tinder: {
    iconUrl: '/images/large/tinder.svg',
    logoUrl: '/images/small/tinder-s.svg',
    color: '#F95840',
    name: 'Tinder',
  },
  'spotify-premium': {
    iconUrl: '/images/large/spotify-premium.svg',
    logoUrl: '/images/small/spotify-s.svg',
    color: '#3CE68C',
    name: 'Spotify Premium',
  },
  'spotify-gift-card': {
    iconUrl: '/images/large/spotify-gift-card.svg',
    logoUrl: '/images/small/spotify-s.svg',
    color: '#3CE68C',
    name: 'Spotify gift card',
  },
  roblox: {
    iconUrl: '/images/large/roblox.svg',
    logoUrl: '/images/small/roblox-s.svg',
    color: '#FFFFFF',
    name: 'Roblox gift card',
  },
  'riot-cash-card': {
    iconUrl: '/images/large/riot-cash-card.svg',
    logoUrl: '/images/small/riot-s.svg',
    color: '#EB0129',
    name: 'Riot Cash Card (EU)',
  },
  'riot-access': {
    iconUrl: '/images/large/riot-access.svg',
    logoUrl: '/images/small/riot-s.svg',
    color: '#EB0129',
    name: 'Riot Access gift card',
  },
  'pubg-newstate': {
    iconUrl: '/images/large/pubg-newstate.svg',
    logoUrl: '/images/small/pubg-newstate-s.svg',
    color: '#212121',
    name: 'PUBG: New State direct',
  },
  'pubg-mobile-direct': {
    iconUrl: '/images/large/pubg-mobile-direct.svg',
    logoUrl: '/images/small/pubg-mobile-s.svg',
    color: '#212121',
    name: 'PUBG Mobile Direct',
  },
  'pubg-mobile': {
    iconUrl: '/images/large/pubg-mobile.png',
    logoUrl: '/images/small/pubg-mobile-s.svg',
    color: '#212121',
    name: 'PUBG Mobile',
  },
  'playstation-store': {
    iconUrl: '/images/large/playstation-store.svg',
    logoUrl: '/images/small/playstation-s.svg',
    color: '#1964BE',
    name: 'PlayStation®Store Wallet gift card',
  },
  'playstation-network-us': {
    iconUrl: '/images/large/playstation-network-us.png',
    logoUrl: '/images/small/playstation-s.svg',
    color: '#1964BE',
    name: 'PlayStation Network (US)',
  },
  'pcs-mastercard-recharge': {
    iconUrl: '/images/large/pcs-mastercard-recharge.svg',
    logoUrl: '/images/small/pcs-s.svg',
    color: '#212121',
    name: 'PCS Mastercard recharge',
  },
  'nintendo-switch-online': {
    iconUrl: '/images/large/nintendo-switch-online.svg',
    logoUrl: '/images/small/nintendo-switch-s.svg',
    color: '#E60011',
    name: 'Nintendo eShop card',
  },
  'nintendo-eshop-card': {
    iconUrl: '/images/large/nintendo-eshop-card.svg',
    logoUrl: '/images/small/nintendo-eshop-s.svg',
    color: '#E60011',
    name: 'Nintendo eShop card',
  },
  'genshin-europe': {
    iconUrl: '/images/large/genshin-europe.svg',
    logoUrl: '/images/small/genshin-s.svg',
    color: '#2E4894',
    name: 'Genshin Europe',
  },
  'genshin-asia': {
    iconUrl: '/images/large/genshin-asia.svg',
    logoUrl: '/images/small/genshin-s.svg',
    color: '#2E4894',
    name: 'Genshin Asia',
  },
  'free-fire-diamonds': {
    iconUrl: '/images/large/free-fire-diamonds.svg',
    logoUrl: '/images/small/free-fire-s.svg',
    color: '#212121',
    name: 'Free Fire Diamonds',
  },
  'free-fire-access': {
    iconUrl: '/images/large/free-fire-access.svg',
    logoUrl: '/images/small/free-fire-s.svg',
    color: '#212121',
    name: 'Free Fire Access',
  },
  'fortnite-v-bucks-card': {
    iconUrl: '/images/large/fortnite.png',
    logoUrl: '/images/small/fortnite-s.svg',
    color: '#FCD602',
    name: 'Fortnite V-Bucks card',
  },
  'ea-gift-card': {
    iconUrl: '/images/large/ea.svg',
    logoUrl: '/images/small/ea-s.svg',
    color: '#F84748',
    name: 'EA gift card',
  },
  'deezer-premium': {
    iconUrl: '/images/large/deezer-premium.svg',
    logoUrl: '/images/small/deezer-premium-s.svg',
    color: '#A238FF',
    name: 'Deezer Premium',
  },
};
